import { Injectable } from '@angular/core';
import * as MixPanel from 'mixpanel-browser'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MixPanelService {

  constructor() { }

  initializeMixPanel() {
    if (environment.production) {
      MixPanel.init(environment.mixPanelToken, {})
    } else {
      MixPanel.init(environment.mixPanelToken, { debug: true })
    }
  }

  trackEvent(eventName: string, properties: any = {}) {
    if (eventName) {
      if (typeof window !== 'undefined' && window.sessionStorage.getItem('sai')) {
        properties['from_sap'] = true;
      }
      if (window.sessionStorage.getItem('rmf')) {
        let _data = JSON.parse(window.sessionStorage.getItem('rmf'));
        properties['from_rm'] = true;
        properties['rm_journeyType'] = _data.journeyType;
        properties['rm_id'] = _data.rmId;
        properties['rm_linkId'] = _data.linkId;
      }
      MixPanel.track(eventName, properties)
    }
  }

  trackLinks(link: string) {
    MixPanel.track_links(link)
  }

  trackForms(eleID: string, eventName: string, properties?: any) {
    MixPanel.track_links(eleID, eventName, properties);
  }

  registerUser(properties) {
    MixPanel.register_once(properties);
  }

  setUserIdentity(mobileNumber: string) {
    MixPanel.identify(mobileNumber)
  }
}
